
import React, { useState, useEffect } from 'react';

const STYLE = {position:'fixed', bottom:0, left:0, height:30, width:'100vw', padding:5, textAlign:'center', color:'white', backgroundColor:'green'} 

export default ({timeout, style, message}) => {
    const [show, setShow]=useState(true)    
    useEffect(() => {
        setShow(message?true:false)
        const timer = setTimeout(() => {
          setShow(undefined);
        }, timeout?timeout:2000);
        return () => clearTimeout(timer);
    }, [message]); 
    const myStyle = style?style:{}
    return (
      show?message?<div style={{...STYLE, ...myStyle}}>{message}</div>
      :null
      :null
    );
};

